import React, { useEffect } from 'react';

const baiDu = {
  width: '100%',
  height: '100%',
};

const BaiduMap = () => {
  useEffect(() => {
    // console.log(document.getElementById('map-container'), '存在吗')
    let map = new BMapGL.Map('map-container');
    map.centerAndZoom(new BMapGL.Point(117.2292, 39.14508), 19);
    map.enableScrollWheelZoom(true);
    let marker = new BMapGL.Marker(new BMapGL.Point(117.2292, 39.14508)); // 创建点
    map.addOverlay(marker);
  }, []);
  return <div id="map-container" style={baiDu}></div>;
};

export default BaiduMap;
